<template>
  <sidebar-nav>
    <toggle/>
    <menubar-link :to="{name: 'admin-modules', params: {organization: id}}">
      <template slot="name">Modules</template>
      <template slot="icon"><i class="fas fa-folder"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'admin-media', params: {organization: id}}">
      <template slot="name">Media</template>
      <template slot="icon"><i class="fas fa-photo-video"></i></template>
    </menubar-link>
    <menubar-link v-if="bioreqEnabled" :to="{name: 'admin-bioreq', params: {organization: id}}">
      <template slot="name">Bioreq</template>
      <template slot="icon"><i class="fas fa-dna"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'admin-reports-knowledgecheck', params: {organization: id}}">
      <template slot="name">Reports</template>
      <template slot="icon"><i class="fas fa-chart-bar"></i></template>
    </menubar-link>
  </sidebar-nav>
</template>

<script>
import menubarLink from '../common/menubar-link'
import sidebarNav from './sidebar-nav'
import toggle from './toggle'
import { mapState } from 'vuex'

export default {
  components: {
    menubarLink,
    sidebarNav,
    toggle
  },
  computed : {
    id () {
      return this.$route.params.organization
    },
    ...mapState('tenants', {
      organization: 'current'
    }),
    bioreqEnabled () {
      return this.organization.enable_bioreq === 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/admin.vue